import { render, staticRenderFns } from "./ui-paid-dropdown.vue?vue&type=template&id=4b3f9543"
import script from "./ui-paid-dropdown.vue?vue&type=script&lang=ts"
export * from "./ui-paid-dropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports